import HomeTap from './taps/homeTap'

import { useEffect, useRef, useState } from 'react'
import { useCookies } from 'react-cookie'

import './explorer.scss'

type ExplorerPorps = {
  explorerSize: number,
  setExplorerSize: (explorerSize: number) => void
}

function Explorer(props: Readonly<ExplorerPorps>) {
  const [cookies] = useCookies(['themen'])
  const [mousePosition] = useState({ x: 0 })
  const holdCountRef = useRef(mousePosition)
  const [isHolding, setIsHolding] = useState(false)

  const handleMouseMove = (event: MouseEvent) => {
    holdCountRef.current = { x: event.clientX - 60 }
  }

  useEffect(() => {
    if(cookies.themen) {
      document.getElementById('theme')?.classList.add(cookies.themen)
    }

    window.addEventListener('mousemove', handleMouseMove)
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
    }
  }, [])
  
  useEffect(() => {
    let interval: NodeJS.Timeout | undefined
    if (isHolding) {
      interval = setInterval(() => {

        if(holdCountRef.current.x < 180) {
          props.setExplorerSize(0)
        } else if((window.innerWidth- 400) < holdCountRef.current.x) {
          props.setExplorerSize(window.innerWidth- 400)
        } else {
          props.setExplorerSize(holdCountRef.current.x)
        }

      }, 1) // Intervallzeit in Millisekunden
    } else if (!isHolding) {
      clearInterval(interval)
    }
    return () => clearInterval(interval)
  }, [isHolding])

  const handleMouseDown = () => {
    setIsHolding(true)
  }

  const handleMouseUp = () => {
    setIsHolding(false)
  }

  const handleMouseLeave = () => {
    setIsHolding(false)
  }

  return (
    <div className='comp-explorer'>
      {isHolding ? (
        <div 
          className='explorer-fullScreenStopper'
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseLeave}
        />
      ) : null}

      <div className='explorer-content'>
        <HomeTap />
      </div>

      <div
        className={`explorer-mouseBar ${isHolding ? 'explorer-mouseBarActive' : ''} ${!isHolding && props.explorerSize <= 0 ? 'explorer-mouseBarClose' : ''}`}
        onMouseDown={handleMouseDown}          
      />
    </div>
  )
}

export default Explorer
